//#region Styles
import {
    Row, 
    Column, 
    Part, 
    TitleSection, 
    Fields, 
    SubtitleSection
} from "components/styles";
//#endregion
//#region Components
import HandlerRadio from "components/CustomRadio/CustomRadio";
import NotificationNoContent from "components/NotificationNoContent/NotificationNoContent";
//#endregion
//#region Utils
import { filterCampusVirtual } from "services/general";
import ZoomControls from "./components/ZoomControls/ZoomControls";
import PlaceControls from "./components/PlaceControls/PlaceControls";
//#endregion

const LocationPartForm = ({
    form, changeField, 
    errors, errorTexts, 
    locations, allCampus, 
    inscriptionTypes, 
    campusEnvironments,
    teacherZoomAccountDetail, 
    fillTeacherZoomAccountDetail, as,
    onlyInCampus = false
}) => {
    //#region Effects
    //#endregion
    //#region Functions
    const handlerLocationIdField = (value) => {
        changeField("locationId", value, false);
        fillTeacherZoomAccountDetail && fillTeacherZoomAccountDetail({
            locationId: value
        });
    }
    const changePlace = (field, value, errorValue) => {
        changeField("place", {
            ...form.place, 
            [field]: value
        }, {
            ...errors.place,
            [field]: errorValue
        });
    }
    const changePlaceCampus = ({ id, text }) => {
        changeField("place", {
            "campus": { id, name: text },
            "environment": {
                ...form.place.environment, 
                inCampus: {
                    id: 0, 
                    address: "",
                    floor: ""
                }
            }
        }, {
            ...errors.place,
            "campus": false,
            "environment": errors.place.environment
        });
    }
    const changePlaceCampusOnlyInCampus = ({ 
        id, 
        text: name 
    }) => {
        changeField("place", {
            "campus": { id, name },
            "environment": {
                ...form.place.environment,
                address: allCampus.find(({ id: idCampus }) => idCampus === id)?.address || "-"
            }
        }, {
            ...errors.place,
            "campus": false,
            "environment": errors.place.environment
        });
    }
    const changePlaceEnvironment = (field, value, errorValue) => {
        changePlace("environment", {
            ...form.place.environment, 
            [field]: value 
        }, {
            ...errors.place.environment,
            [field]: errorValue
        });
    }
    const getAllCampusForLocationSearch = () => {
        return filterCampusVirtual(allCampus);
    }
    //#endregion
    const { locationId, place } = form;
    return (
        <Part>
            <Fields>
                <Column gap="20px">
                    <TitleSection>Ubicación:</TitleSection>
                    <Row className="flex-start" gap="40px">
                        <HandlerRadio
                            value={locationId}
                            onChange={handlerLocationIdField}
                            radiosProps={
                                locations.map(({ 
                                        id, 
                                        name,
                                        icon 
                                    }) => ({
                                    value: id, 
                                    label: name,
                                    icon: <img src={icon} alt={name}/>
                                }))
                            }
                            error={errors.locationId}
                            errorText={errorTexts?.location || "Es necesario seleccionar una ubicación."}/>
                    </Row>
                    {locationId === 1 
                    ? <ZoomControls 
                        as={as}
                        data={{
                            inscriptionTypes
                        }}
                        form={form} changeField={changeField}
                        errors={errors} errorTexts={errorTexts}
                        teacherZoomAccountDetail={teacherZoomAccountDetail}/>
                    : locationId === 2 
                        ? <PlaceControls 
                            as={as}
                            data={{
                                campusEnvironments,
                                fn: { getAllCampusForLocationSearch }
                            }}
                            form={place}
                            errors={errors}
                            changeFields={{
                                changePlaceCampus,
                                changePlaceCampusOnlyInCampus,
                                changePlaceEnvironment
                            }}
                            onlyInCampus={onlyInCampus}/>
                        : <NotificationNoContent
                            title="Aún no has señalado una ubicación"
                            description={`Selecciona una para mostrarte las opciones de cómo asistir al ${as}`}/> }
                </Column>
            </Fields>
        </Part>
    );
}

export default LocationPartForm;